import { useState } from 'react';
import formatDisclosureWithDate from './formatDisclosureWithDate';
import useEffectOnce from './reactHooks';

const host = window.__config__.CONTROL_CENTER_URL;
const disclosuresFile = '/disclosures/disclosures.json';

export interface DisclosureResponse {
  apyCds: string;
  apyHysMoneyMarket: string;
  apyNonIraCds: string;
  transfers: string;
}

const initialDisclosures: DisclosureResponse = {
  apyCds: '',
  apyHysMoneyMarket: '',
  apyNonIraCds: '',
  transfers: '',
};

export const fetchDisclosures = async (): Promise<DisclosureResponse> => {
  try {
    const response = await fetch(`${host}${disclosuresFile}`);
    const data: DisclosureResponse = await response.json();

    // Replace occurrences of %today% with today's date
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (typeof value === 'string' && value.includes('%today%')) {
        data[key] = formatDisclosureWithDate(value);
      }
    });

    return data;
  } catch (err) {
    console.error(err);
    // Return blank disclosures object for type safety
    return initialDisclosures;
  }
};

export const useDisclosures = () => {
  const [disclosures, setDisclosures] = useState<DisclosureResponse>(initialDisclosures);

  useEffectOnce(() => {
    fetchDisclosures().then((data) => {
      setDisclosures(data);
    });
  });

  return disclosures;
};
